import type { FC } from "react";

import { useClientContext } from "~/contexts/client-context";
import type { Pages, SecondaryLayoutData } from "~/core";
import { SecondaryFooter } from "~/features/secondary-footer/SecondaryFooter";
import { useAction } from "~/widgets/use-action";

export const SecondaryLayoutFooter: FC<{ data: SecondaryLayoutData }> = ({
  data,
}) => {
  const { callAction: onCallAction, isActionInactive } = useAction("footer");

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };
  const { language, availableLanguages, languages, hreflangAlternates } =
    useClientContext();
  const footerData = {
    ...data,
    language,
    availableLanguages: availableLanguages ?? [],
    languages: languages ?? [],
    hreflangAlternates,
  };
  return (
    <SecondaryFooter
      data={footerData}
      onCallAction={onCallAction}
      isActionInactive={isActionInactive}
      getUrl={getUrl}
    />
  );
};
